import { labelCls } from "@/components/Ui";

/** Tick-list of the platform's published categories — free text broke RFQ matching. */
export const CategoryPicker = ({ label, hint, options = [], value = [], onChange, testId }) => (
  <div data-testid={testId}>
    <label className={labelCls}>{label}</label>
    {hint && <p className="mt-1 text-xs text-[#8598ac]">{hint}</p>}
    <div className="mt-2 grid max-h-[220px] gap-1.5 overflow-y-auto rounded-[10px] border border-[#DFE6ED] bg-white p-3 sm:grid-cols-2">
      {options.length === 0 && (
        <p className="text-xs text-[#8598ac]">Loading categories…</p>
      )}
      {options.map((c) => {
        const checked = value.includes(c);
        return (
          <label key={c} className="flex cursor-pointer items-start gap-2 text-xs text-[#334e68]">
            <input
              type="checkbox"
              data-testid={`${testId}-option-${c}`}
              checked={checked}
              onChange={() => onChange(checked ? value.filter((x) => x !== c) : [...value, c])}
              className="mt-0.5 h-4 w-4 shrink-0 accent-[#147D78]"
            />
            <span>{c}</span>
          </label>
        );
      })}
    </div>
    <p className="mt-1.5 text-xs text-[#8598ac]" data-testid={`${testId}-count`}>
      {value.length} selected — you only receive enquiries in the categories you tick.
    </p>
  </div>
);
